import { useEffect } from "react";
import "@/components/escape21/escape21.css";
import Hero from "@/components/portfolio/Hero";
import Metrics from "@/components/portfolio/Metrics";
import ProfileProof from "@/components/portfolio/ProfileProof";
import ReelsGrid from "@/components/portfolio/ReelsGrid";
import TikTok from "@/components/portfolio/TikTok";
import DailyQuestions from "@/components/portfolio/DailyQuestions";
import SalesProof from "@/components/portfolio/SalesProof";
import Carousels from "@/components/portfolio/Carousels";
import StaticPosts from "@/components/portfolio/StaticPosts";
import YouTube from "@/components/portfolio/YouTube";
import About from "@/components/portfolio/About";
import Collab from "@/components/portfolio/Collab";
import FinalCta from "@/components/portfolio/FinalCta";
import Footer from "@/components/portfolio/Footer";

const Portfolio = () => {
  useEffect(() => {
    document.title = "media kit · dudu crespo";
  }, []);

  return (
    <div className="min-h-screen bg-black font-sans text-white antialiased">
      {/* grain sutil por cima de tudo */}
      <div className="e21-grain" aria-hidden="true" />

      <Hero />
      <Metrics />
      <ProfileProof />
      <ReelsGrid />
      <TikTok />
      <DailyQuestions />
      <SalesProof />
      <Carousels />
      <StaticPosts />
      <YouTube />
      <About />
      <Collab />
      <FinalCta />
      <Footer />
    </div>
  );
};

export default Portfolio;
